__turbopack_context__.v({
  "orderButton": "basket-summary-module-scss-module__7Cs5ea__orderButton",
  "title": "basket-summary-module-scss-module__7Cs5ea__title",
  "tooltipText": "basket-summary-module-scss-module__7Cs5ea__tooltipText",
});
